var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.398 6.005H6.602a.6.6 0 0 0 0 1.2h10.796a.6.6 0 0 0 0-1.2ZM17.398 9.604H6.602a.6.6 0 0 0 0 1.2h10.796a.6.6 0 1 0 0-1.2ZM17.398 13.202H6.602a.6.6 0 0 0 0 1.2h10.796a.6.6 0 0 0 0-1.2ZM12 16.802H6.602a.6.6 0 0 0 0 1.2H12a.6.6 0 1 0 0-1.2Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.858 2.946A11.997 11.997 0 0 0 9.505.259 11.9 11.9 0 0 0 .172 9.964a12.068 12.068 0 0 0 2.591 9.692.576.576 0 0 1 0 .78L.232 22.98a.564.564 0 0 0-.132.648.6.6 0 0 0 .504.372h11.072a12.164 12.164 0 0 0 12.296-11.276 11.876 11.876 0 0 0-4.114-9.777Zm2.915 9.705a10.965 10.965 0 0 1-11.097 10.148H2.08l1.512-1.511a1.763 1.763 0 0 0 .12-2.4 10.796 10.796 0 0 1-2.327-8.733A10.689 10.689 0 0 1 9.78 1.422a10.796 10.796 0 0 1 9.333 2.4 10.796 10.796 0 0 1 3.659 8.829Z",
    fill: "#fff"
  })));
};

export default SvgChat;